<template>
  <v-dialog v-model="dialog" persistent max-width="550">
    <v-card v-if="Transaction" grid-list-md>
      <v-toolbar dense class="mb-3" flat color="grey lighten-3">
        <v-app-bar-nav-icon v-if="count > 0" @click="goBack">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title class="subtitle-1 text-capitalize">{{addSpace(toolbarTitle[count])}}</v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-btn small icon @click.stop.prevent="close()">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-btn color="success" @click="getTransaction()">Re-Sync Transaction Status</v-btn>
        <v-list class="list-350">
          <template v-for="(value, key) in listData[count]">
            <v-list-item :key="key">
              <v-list-item-content :class="isObject(value) ? 'pointer' : ''" @click="isObject(value) ? showObject(value, key) : undefined">
                <div class="text-left text-capitalize">{{ addSpace(key) }}</div>
              </v-list-item-content>
              <v-list-item-content @click="isObject(value) ? showObject(value, key) : undefined">
                <div class="text-right" v-if="!value">--</div>
                <div class="text-right" v-else-if="typeof value !== 'object'">{{ value }}</div>
                <div class="text-right text-decoration-underline blue--text pointer" v-else>
                  <v-icon>mdi-chevron-right</v-icon>
                </div>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import payCompassService from "@/modules/PayCompass/service.js";

export default {
  name: "open-transaction-detail",
  props: {
    openTransactionDetail: {
      default: false,
    },
    selectedTransaction: {
      type: Object,
    },
  },
  data() {
    return {
      dialog: false,
      Transaction: null,
      toolbarTitle: [],
      listData: [],
      count: 0
    };
  },
  watch: {
    openTransactionDetail(val) {
      this.dialog = val;
      if(val){
        this.Transaction = this.selectedTransaction;
        this.listData.push(this.selectedTransaction.metadata);
        this.toolbarTitle.push('Transaction Detail');
        console.log('listData', this.listData)
      }
    },
  },
  methods: {
    getTransaction() {
      console.log('Tran', this.Transaction)
      payCompassService.getTransactionById(this.Transaction.id).then(response => {
        console.log('response payment', response)

      }).catch(error => {
        console.log('error stripe', error)
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: error.data.message,
          });
      })
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    addSpace(string){
      return string.replace(/_/g, " ");
    },
    isObject(val){
      if(val && typeof val === 'object')
        return true;
      return false
    },
    empty() {
      this.Transaction = null;
      this.listData = [];
      this.count = 0;
      this.toolbarTitle = [];
    },
    showObject(val, key){
      this.listData.push(val);
      this.toolbarTitle.push(key)
      this.count++;
    },
    goBack(){
      this.listData.pop();
      this.toolbarTitle.pop();
      this.count--;
    }
  },
};
</script>

<style scoped>
</style>
